import React from "react";
import styled from "styled-components/macro";
import Link from "ui/Link";
import Stack from "ui/Stack";
import Typography from "ui/Typography";
import { theme } from "ui/theme";
import TeacherAccount from "ui/Icons/TeacherAccount";
import Inline from "ui/Inline";
import { transition } from "helpers/css";
import BackpackImage from "images/backpack.png";
import AppleImage from "images/apple.png";
import CoffeeCupImage from "images/coffee_cup.png";

const $RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  justify-content: center;
`;

const $RowLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  span {
    ${transition("color .2s ease-out")}
  }

  &:hover,
  &:focus {
    text-decoration: none;
    span {
      color: ${theme.ColorBlurple500};
    }
  }
`;

const $RowDivider = styled.div`
  @media screen and (${theme.BreakpointPhoneUp}) {
    border: 1px solid ${theme.ColorSpace100};
    border-width: 0 1px 0 0;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
`;

const $RowText = styled.div`
  padding-top: 1rem;
`;

const $Image = styled.img`
  width: 9.75rem;
  height: 9.75rem;
`;

const $SchoolLeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const $CoffeeImage = styled.img`
  width: 7.75rem;
  height: 7.75rem;
  margin-bottom: 1rem;
`;

const $SchoolsPageText = styled.div`
  width: 30rem;
  padding-top: 1rem;

  @media screen and (${theme.BreakpointLargeTabletDown}) {
    width: 20rem;
  }
`;

const $LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  svg {
    margin-left: 0.5rem;
    margin-right: 0.25rem;
  }
`;

const $AccountTypeText = styled(Typography).attrs({
  size: "h3",
  forwardedAs: "span",
})``;

export default function SelectUserType() {
  return (
    <>
      <Typography size="bodySansSerif">
        Create your free account as a:
      </Typography>
      <$RowContainer>
        <$RowLink
          key="Student"
          analyticsName="clicked_student_type"
          href="connect"
        >
          <$Image role="presentation" src={BackpackImage} />
          <$AccountTypeText>Student</$AccountTypeText>
        </$RowLink>
        <$RowDivider />
        <$RowLink
          key="Educator"
          analyticsName="clicked_educator_type"
          href="educator_signup"
        >
          <$Image role="presentation" src={AppleImage} />
          <$AccountTypeText>Educator</$AccountTypeText>
        </$RowLink>
      </$RowContainer>
      <$SchoolLeaderSection>
        <$RowLink
          key="SchoolLeader"
          analyticsName="clicked_school_leader_type"
          aria-label="For-schools page"
          href="https://www.along.org/for-schools/#contact-form"
        >
          <$CoffeeImage role="presentation" src={CoffeeCupImage} />
          <$AccountTypeText>Are you a school leader?</$AccountTypeText>
        </$RowLink>
        <$SchoolsPageText>
          <Typography size="bodySansSerif">
            To bring Along to your school,{" "}
            <Link
              href="https://www.along.org/for-schools/#contact-form"
              analyticsName="clicked_schools_link"
            >
              visit our For Schools page.
            </Link>{" "}
          </Typography>
        </$SchoolsPageText>
      </$SchoolLeaderSection>
      <Stack $align="center">
        <$RowText>
          <Inline alignY="center">
            <Typography size="bodySansSerif" fontWeight="bold">
              Already have an account?
            </Typography>
            <$LinkWrapper>
              <TeacherAccount role="img" size="sm" title="account profile" />
              <Link href="/" analyticsName="clicked_sign_in">
                Sign In
              </Link>
            </$LinkWrapper>
          </Inline>
        </$RowText>
      </Stack>
    </>
  );
}
